import { render, staticRenderFns } from "./WorkRecordForm.vue?vue&type=template&id=f3f6d018&scoped=true"
import script from "./WorkRecordForm.vue?vue&type=script&lang=js"
export * from "./WorkRecordForm.vue?vue&type=script&lang=js"
import style0 from "./WorkRecordForm.vue?vue&type=style&index=0&id=f3f6d018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f6d018",
  null
  
)

export default component.exports